const CODESYS_ST_SYNTAX_RULES = [
    "## CODESYS 文法",
    "- 宣言部と実装部（本体）を分けて出力し、本体に宣言を混在させない",
    "- Program POU の宣言部は先頭の PROGRAM <名前> 行を必ず含める（POU 名行を省略・削除しない）",
    "- 定数は宣言部に VAR CONSTANT … END_VAR で宣言する。CONST / END_CONST という構文は存在しないので使わない",
    "- TIME リテラルは T#500ms の形式で書く"
];

const BUTTON_MODE_GEN_RULES = [
    "## ボタン入力の扱い",
    "- フローのボタンノードは mode を持つ。momentary は押している間だけ ON（入力レベルをそのまま使う）",
    "- alternate（オルタネート）は R_TRIG で立ち上がりを検出し、内部の保持変数を反転させ、保持中は出力を継続する（離しても状態維持）"
];

// 「## 生成ルール」内に展開する点滅関連の行（永続オシレータ＋出力ゲート）。
const BLINK_GEN_RULES = [
    "- 点滅は TON などの IEC タイマで周期反転し、スキャンごとの単純トグルで点滅とみなさない",
    "- 信号出力の BLINK は、スキャン毎に走る自己リセット TON で位相変数を生成する常時オシレータとして実装する",
    "- 点滅は一過性のステップ動作にせず、駆動状態（保持変数）が真の間は継続し、偽になったら出力を FALSE にする（出力は 駆動状態 AND 位相 でゲート）",
    "- 点滅周期が未指定の場合は 500ms を仮置きし、仮置きであることを明示する"
];

const WAGO_CC100_BLINK_GUARD_RULES = [
    "- TON.Q をそのまま点滅位相や物理出力へ割り当てない。タイマ満了時に内部位相ビットを反転して点滅を表現する",
    "- 同一の TON / TOF / TP インスタンスを 1 スキャン内で複数回呼ばない。タイマ FB 呼び出しは原則 1 回にまとめる",
    "- 点滅停止時は位相ビット、タイマ入力、物理出力を明示的に FALSE 側へ戻す"
];

const WAGO_CC100_DECLARATION_RULES = [
    "- ST コード内で参照する X_ / Y_ / M_ 信号とローカル変数は、宣言部に不足なく記載する",
    "- GVL または I/O Mapping で別途定義済みという前提を、根拠が無いまま勝手に作らない",
    "- I/O Mapping 済みの外部変数を参照して宣言を省略するのは、制御仕様・信号一覧・FlowContext のいずれかに外部定義済みの根拠がある場合だけにする",
    "- 外部定義済みか確認できない場合は、その前提を書かず、不足情報として明示するか、たたき台として宣言部に信号を含める",
    "- 入出力信号、保持ビット、タイマ、位相変数などには用途が分かる簡潔なコメントを付ける"
];

const CODESYS_ST_PROMPT_RULES = [
    "## 対象",
    "- CODESYS ST 向け",
    "",
    "## 基本方針",
    "- I/O Mapping を優先し、制御仕様に address がある場合はその信号が I/O Mapping 済みである前提で扱う",
    "- POU の VAR_INPUT / VAR_OUTPUT はインターフェースとして扱い、物理 I/O アドレスの AT 指定は付けない",
    "- AT 指定を例示する場合は VAR_GLOBAL の I/O 変数に限定する",
    "- PROGRAM 内はローカル状態変数とタイマ変数を中心にし、実 I/O はグローバル I/O 変数または I/O Mapping された変数を参照する",
    "",
    ...CODESYS_ST_SYNTAX_RULES,
    "",
    ...BUTTON_MODE_GEN_RULES,
    "",
    "## 生成ルール",
    ...BLINK_GEN_RULES
].join("\n");

const WAGO_CC100_CODESYS_PROMPT_RULES = [
    "## 対象",
    "- WAGO CC100 (751-9401) + CODESYS 3.5 向け",
    "",
    "## I/O 方針",
    "- I/O Mapping は、制御仕様・信号一覧・FlowContext のいずれかに外部定義済みの根拠が確認できる場合に限って優先する",
    "- 入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix とし、信号名は X_ / Y_ / M_ を優先する",
    "- 照光式ボタンは接点入力と LED 出力を別信号として扱う",
    "",
    ...CODESYS_ST_SYNTAX_RULES,
    "",
    ...BUTTON_MODE_GEN_RULES,
    "",
    "## 生成ルール",
    "- コード生成は宣言部とプログラム本体部分を分け、それぞれ別の ```st コードブロックで出力する",
    "- POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する",
    ...WAGO_CC100_DECLARATION_RULES,
    ...BLINK_GEN_RULES,
    ...WAGO_CC100_BLINK_GUARD_RULES
].join("\n");

const LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES = [
    "WAGO CC100 + CODESYS 実機確認向け。CODESYS ST のルールを継承し、I/O Mapping を最優先する。",
    "対象ハードは WAGO CC100 (751-9401) 標準仕様。標準 I/O 構成はデジタル入力 8 点、デジタル出力 4 点、アナログ入力 2 点、アナログ出力 2 点、温度入力 2 点、RS-485 1 ポートを基準に扱う。",
    "通信・周辺機能は 2 x Ethernet、CAN、CANopen、SD を備える標準仕様として扱う。",
    "開発前提は CODESYS 3.5。必要に応じて内蔵 Web Server / HTML5 可視化を使える前提で考える。",
    "制御仕様に登録された address、direction、description を I/O 根拠として使い、CC100 DI/DO の対応を回答と生成コードに反映する。",
    "入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix として扱う。ただし実機の I/O Mapping と制御仕様を優先する。",
    "信号名は入力 X_、出力 Y_、内部 M_ を優先する。",
    "照光式ボタンなどの実機テストでは、接点入力とランプ出力を別信号として扱う。",
    "POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する。",
    "点滅周期が未指定の場合は 500ms を仮置きし、仮置きであることを明示する。"
].join("\n");

const LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_BLINK_GUARD = [
    "## 対象",
    "- WAGO CC100 + CODESYS 実機確認向け",
    "- CODESYS ST のルールを継承し、I/O Mapping を最優先する",
    "",
    "## 標準仕様",
    "- 対象ハードは WAGO CC100 (751-9401)",
    "- 標準 I/O 構成は DI 8点 / DO 4点 / AI 2点 / AO 2点 / 温度入力 2点 / RS-485 1ポート",
    "- 通信・周辺機能は 2 x Ethernet / CAN / CANopen / SD",
    "- 開発前提は CODESYS 3.5。必要に応じて内蔵 Web Server / HTML5 可視化を使える前提で考える",
    "",
    "## I/O ルール",
    "- 制御仕様に登録された address / direction / description を I/O 根拠として使い、CC100 DI/DO の対応を回答と生成コードに反映する",
    "- 入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix として扱う。ただし実機の I/O Mapping と制御仕様を優先する",
    "- 信号名は入力 X_、出力 Y_、内部 M_ を優先する",
    "- 照光式ボタンなどの実機テストでは、接点入力とランプ出力を別信号として扱う",
    "",
    ...CODESYS_ST_SYNTAX_RULES,
    "",
    ...BUTTON_MODE_GEN_RULES,
    "",
    "## 生成ルール",
    "- コード生成は宣言部とプログラム本体部分を分け、それぞれ別の ```st コードブロックで出力する",
    "- POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する",
    ...BLINK_GEN_RULES
].join("\n");

const LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_COMPACT = [
    "## 対象",
    "- WAGO CC100 + CODESYS 実機確認向け",
    "- CODESYS ST のルールを継承し、I/O Mapping を最優先する",
    "",
    "## 標準仕様",
    "- 対象ハードは WAGO CC100 (751-9401)",
    "- 標準 I/O 構成は DI 8点 / DO 4点 / AI 2点 / AO 2点 / 温度入力 2点 / RS-485 1ポート",
    "- 通信・周辺機能は 2 x Ethernet / CAN / CANopen / SD",
    "- 開発前提は CODESYS 3.5。必要に応じて内蔵 Web Server / HTML5 可視化を使える前提で考える",
    "",
    "## I/O ルール",
    "- 制御仕様に登録された address / direction / description を I/O 根拠として使い、CC100 DI/DO の対応を回答と生成コードに反映する",
    "- 入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix として扱う。ただし実機の I/O Mapping と制御仕様を優先する",
    "- 信号名は入力 X_、出力 Y_、内部 M_ を優先する",
    "- 照光式ボタンなどの実機テストでは、接点入力とランプ出力を別信号として扱う",
    "",
    ...CODESYS_ST_SYNTAX_RULES,
    "",
    ...BUTTON_MODE_GEN_RULES,
    "",
    "## 生成ルール",
    "- コード生成は宣言部とプログラム本体部分を分け、それぞれ別の ```st コードブロックで出力する",
    "- POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する",
    ...BLINK_GEN_RULES,
    ...WAGO_CC100_BLINK_GUARD_RULES
].join("\n");

const LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_DECLARATION_CLARITY = [
    "## 対象",
    "- WAGO CC100 (751-9401) + CODESYS 3.5 向け",
    "",
    "## I/O 方針",
    "- I/O Mapping を最優先し、制御仕様の address / direction / description を根拠に使う",
    "- 入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix とし、信号名は X_ / Y_ / M_ を優先する",
    "- 照光式ボタンは接点入力と LED 出力を別信号として扱う",
    "",
    ...CODESYS_ST_SYNTAX_RULES,
    "",
    ...BUTTON_MODE_GEN_RULES,
    "",
    "## 生成ルール",
    "- コード生成は宣言部とプログラム本体部分を分け、それぞれ別の ```st コードブロックで出力する",
    "- POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する",
    ...BLINK_GEN_RULES,
    ...WAGO_CC100_BLINK_GUARD_RULES
].join("\n");

const LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_IO_MAPPING_CONDITIONAL = [
    "## 対象",
    "- WAGO CC100 (751-9401) + CODESYS 3.5 向け",
    "",
    "## I/O 方針",
    "- I/O Mapping を最優先し、制御仕様の address / direction / description を根拠に使う",
    "- 入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix とし、信号名は X_ / Y_ / M_ を優先する",
    "- 照光式ボタンは接点入力と LED 出力を別信号として扱う",
    "",
    ...CODESYS_ST_SYNTAX_RULES,
    "",
    ...BUTTON_MODE_GEN_RULES,
    "",
    "## 生成ルール",
    "- コード生成は宣言部とプログラム本体部分を分け、それぞれ別の ```st コードブロックで出力する",
    "- POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する",
    ...WAGO_CC100_DECLARATION_RULES,
    ...BLINK_GEN_RULES,
    ...WAGO_CC100_BLINK_GUARD_RULES
].join("\n");

// CODESYS 文法セクション追加前の WAGO 既定ルール。手編集していないユーザープロファイルだけを新ルールへ移行する。
const LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_SYNTAX = [
    "## 対象",
    "- WAGO CC100 + CODESYS 実機確認向け",
    "- CODESYS ST のルールを継承し、I/O Mapping を最優先する",
    "",
    "## 標準仕様",
    "- 対象ハードは WAGO CC100 (751-9401)",
    "- 標準 I/O 構成は DI 8点 / DO 4点 / AI 2点 / AO 2点 / 温度入力 2点 / RS-485 1ポート",
    "- 通信・周辺機能は 2 x Ethernet / CAN / CANopen / SD",
    "- 開発前提は CODESYS 3.5。必要に応じて内蔵 Web Server / HTML5 可視化を使える前提で考える",
    "",
    "## I/O ルール",
    "- 制御仕様に登録された address / direction / description を I/O 根拠として使い、CC100 DI/DO の対応を回答と生成コードに反映する",
    "- 入力は %IX、出力は %QX、内部メモリは %MX を基本 prefix として扱う。ただし実機の I/O Mapping と制御仕様を優先する",
    "- 信号名は入力 X_、出力 Y_、内部 M_ を優先する",
    "- 照光式ボタンなどの実機テストでは、接点入力とランプ出力を別信号として扱う",
    "",
    "## 生成ルール",
    "- POU の VAR_INPUT / VAR_OUTPUT に AT を付けない。アドレスを明示する例は VAR_GLOBAL の I/O 変数に限定する",
    "- 点滅周期が未指定の場合は 500ms を仮置きし、仮置きであることを明示する"
].join("\n");

const DEFAULT_USER_PROFILE_DEFINITIONS = Object.freeze([
    {
        id: "wago-cc100-codesys",
        name: "WAGO CC100 CODESYS",
        description: "WAGO CC100 + CODESYS 実機確認向け user profile",
        editable: true,
        baseProfileId: "codesys-st",
        baseFamily: "codesys",
        vendorTarget: "codesys-st",
        stepVar: "Step",
        startSignal: "StartCmd",
        comment: "WAGO CC100 CODESYS draft",
        promptRules: WAGO_CC100_CODESYS_PROMPT_RULES,
        hardware: {
            targetName: "WAGO CC100",
            controllerModel: "CC100",
            ioSummary: "標準仕様: DI 8点 / DO 4点 / AI 2点 / AO 2点 / 温度入力 2点 / RS-485 1ポート / 2 x Ethernet / CAN / CANopen / SD / CODESYS 3.5。制御仕様と I/O Mapping を優先する。",
            inputAddressPrefix: "%IX",
            outputAddressPrefix: "%QX",
            memoryAddressPrefix: "%MX"
        },
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: false,
            preferIoMapping: true,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true,
            inputAddressPrefix: "%IX",
            outputAddressPrefix: "%QX",
            memoryAddressPrefix: "%MX"
        },
        naming: {
            inputPrefix: "X_",
            outputPrefix: "Y_",
            internalPrefix: "M_"
        }
    }
]);

const BUILTIN = Object.freeze([
    {
        id: "generic-st",
        name: "Generic IEC ST",
        description: "汎用 IEC 61131-3 Structured Text",
        editable: false,
        baseFamily: "iec61131-3",
        vendorTarget: "generic-st",
        stepVar: "Step",
        startSignal: "StartCmd",
        comment: "Generic draft",
        promptRules: "ベンダー固有構文へ寄せず、IEC 61131-3 として素直な ST を優先する。I/O アドレスは未確定なら断定しない。",
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: true,
            preferIoMapping: false,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true
        },
        naming: {}
    },
    {
        id: "mitsubishi-gxworks3",
        name: "Mitsubishi GX Works3",
        description: "三菱 GX Works3 向け",
        editable: false,
        baseFamily: "mitsubishi",
        vendorTarget: "mitsubishi-gxworks3",
        stepVar: "iStep",
        startSignal: "X_StartCmd",
        comment: "Mitsubishi-flavored draft",
        promptRules: "三菱 GX Works3 向けの命名と実装感に寄せる。",
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: true,
            preferIoMapping: false,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true
        },
        naming: {}
    },
    {
        id: "omron-sysmac",
        name: "Omron Sysmac Studio",
        description: "オムロン Sysmac Studio 向け",
        editable: false,
        baseFamily: "omron",
        vendorTarget: "omron-sysmac",
        stepVar: "StepNo",
        startSignal: "StartCmd",
        comment: "Sysmac-flavored draft",
        promptRules: "Sysmac Studio 向けの構成と命名を優先する。",
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: true,
            preferIoMapping: false,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true
        },
        naming: {}
    },
    {
        id: "keyence-kv",
        name: "Keyence KV Studio",
        description: "キーエンス KV Studio 向け",
        editable: false,
        baseFamily: "keyence",
        vendorTarget: "keyence-kv",
        stepVar: "StepNo",
        startSignal: "StartTrig",
        comment: "KV-flavored draft",
        promptRules: "KV Studio 向けの構成と命名を優先する。",
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: true,
            preferIoMapping: false,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true
        },
        naming: {}
    },
    {
        id: "codesys-st",
        name: "CODESYS ST",
        description: "CODESYS 汎用 ST",
        editable: false,
        baseFamily: "codesys",
        vendorTarget: "codesys-st",
        stepVar: "Step",
        startSignal: "StartCmd",
        comment: "CODESYS draft",
        promptRules: CODESYS_ST_PROMPT_RULES,
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: false,
            preferIoMapping: true,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true
        },
        naming: {}
    },
    {
        id: "wago-cc100-codesys",
        name: "WAGO CC100 CODESYS",
        description: "WAGO CC100 + CODESYS 実装向け",
        editable: false,
        baseFamily: "codesys",
        vendorTarget: "codesys-st",
        stepVar: "Step",
        startSignal: "StartCmd",
        comment: "WAGO CC100 CODESYS draft",
        promptRules: WAGO_CC100_CODESYS_PROMPT_RULES,
        hardware: {
            targetName: "WAGO CC100",
            controllerModel: "CC100",
            ioSummary: "標準仕様: DI 8点 / DO 4点 / AI 2点 / AO 2点 / 温度入力 2点 / RS-485 1ポート / 2 x Ethernet / CAN / CANopen / SD / CODESYS 3.5。制御仕様と I/O Mapping を優先する。",
            inputAddressPrefix: "%IX",
            outputAddressPrefix: "%QX",
            memoryAddressPrefix: "%MX"
        },
        codegen: {
            declarationBlock: "VAR_GLOBAL",
            includeAddressesInDeclarations: false,
            preferIoMapping: true,
            defaultBlinkMs: 500
        },
        ioPolicy: {
            allowAtOnPouInterface: false,
            preferGlobalIoVariables: true,
            inputAddressPrefix: "%IX",
            outputAddressPrefix: "%QX",
            memoryAddressPrefix: "%MX"
        },
        naming: {
            inputPrefix: "X_",
            outputPrefix: "Y_",
            internalPrefix: "M_"
        }
    }
]);

function slugify(value = "") {
    return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

export function listBuiltInPlcProfiles() {
    return BUILTIN.map((profile) => ({ ...profile }));
}

export function getBuiltInPlcProfile(id = "") {
    return BUILTIN.find((profile) => profile.id === id) || null;
}

function normalizeCodegen(codegen = {}, base = {}) {
    return {
        declarationBlock: String(codegen.declarationBlock || base.declarationBlock || "VAR_GLOBAL").trim() || "VAR_GLOBAL",
        includeAddressesInDeclarations: codegen.includeAddressesInDeclarations !== undefined
            ? Boolean(codegen.includeAddressesInDeclarations)
            : Boolean(base.includeAddressesInDeclarations),
        preferIoMapping: codegen.preferIoMapping !== undefined
            ? Boolean(codegen.preferIoMapping)
            : Boolean(base.preferIoMapping),
        defaultBlinkMs: Number.isFinite(Number(codegen.defaultBlinkMs))
            ? Number(codegen.defaultBlinkMs)
            : (Number.isFinite(Number(base.defaultBlinkMs)) ? Number(base.defaultBlinkMs) : 500)
    };
}

function normalizeIoPolicy(ioPolicy = {}, base = {}) {
    return {
        allowAtOnPouInterface: ioPolicy.allowAtOnPouInterface !== undefined
            ? Boolean(ioPolicy.allowAtOnPouInterface)
            : Boolean(base.allowAtOnPouInterface),
        preferGlobalIoVariables: ioPolicy.preferGlobalIoVariables !== undefined
            ? Boolean(ioPolicy.preferGlobalIoVariables)
            : Boolean(base.preferGlobalIoVariables),
        inputAddressPrefix: String(ioPolicy.inputAddressPrefix || base.inputAddressPrefix || "").trim(),
        outputAddressPrefix: String(ioPolicy.outputAddressPrefix || base.outputAddressPrefix || "").trim(),
        memoryAddressPrefix: String(ioPolicy.memoryAddressPrefix || base.memoryAddressPrefix || "").trim()
    };
}

function normalizeNaming(naming = {}, base = {}) {
    return {
        inputPrefix: String(naming.inputPrefix || base.inputPrefix || "").trim(),
        outputPrefix: String(naming.outputPrefix || base.outputPrefix || "").trim(),
        internalPrefix: String(naming.internalPrefix || base.internalPrefix || "").trim()
    };
}

function normalizeHardware(hardware = {}, base = {}) {
    return {
        targetName: String(hardware.targetName || base.targetName || "").trim(),
        controllerModel: String(hardware.controllerModel || base.controllerModel || "").trim(),
        ioSummary: String(hardware.ioSummary || base.ioSummary || "").trim(),
        inputAddressPrefix: String(hardware.inputAddressPrefix || base.inputAddressPrefix || "").trim(),
        outputAddressPrefix: String(hardware.outputAddressPrefix || base.outputAddressPrefix || "").trim(),
        memoryAddressPrefix: String(hardware.memoryAddressPrefix || base.memoryAddressPrefix || "").trim()
    };
}

function normalizePromptRules(profile = {}, base = {}) {
    const raw = String(profile.promptRules || "").trim();
    if (!raw) return String(base?.promptRules || "").trim();
    if (
        String(profile.id || "") === "wago-cc100-codesys"
        && (raw === LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES
            || raw === LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_SYNTAX
            || raw === LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_BLINK_GUARD
            || raw === LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_COMPACT
            || raw === LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_DECLARATION_CLARITY
            || raw === LEGACY_WAGO_CC100_CODESYS_PROMPT_RULES_PRE_IO_MAPPING_CONDITIONAL)
    ) {
        return WAGO_CC100_CODESYS_PROMPT_RULES;
    }
    return raw;
}

export function normalizePlcProfile(profile = {}, fallbackIndex = 0) {
    const base = getBuiltInPlcProfile(profile.baseProfileId || profile.id || "") || getBuiltInPlcProfile(profile.vendorTarget || "") || getBuiltInPlcProfile("generic-st");
    const name = String(profile.name || base?.name || `Profile ${fallbackIndex + 1}`).trim() || `Profile ${fallbackIndex + 1}`;
    const id = String(profile.id || slugify(name) || `profile-${fallbackIndex + 1}`).trim() || `profile-${fallbackIndex + 1}`;
    return {
        id,
        name,
        description: String(profile.description || base?.description || "").trim(),
        editable: profile.editable !== false,
        baseFamily: String(profile.baseFamily || base?.baseFamily || "iec61131-3").trim() || "iec61131-3",
        vendorTarget: String(profile.vendorTarget || base?.vendorTarget || "generic-st").trim() || "generic-st",
        stepVar: String(profile.stepVar || base?.stepVar || "Step").trim() || "Step",
        startSignal: String(profile.startSignal || base?.startSignal || "StartCmd").trim() || "StartCmd",
        comment: String(profile.comment || base?.comment || "").trim(),
        promptRules: normalizePromptRules(profile, base),
        baseProfileId: String(profile.baseProfileId || base?.id || "generic-st").trim() || "generic-st",
        codegen: normalizeCodegen(profile.codegen, base?.codegen),
        ioPolicy: normalizeIoPolicy(profile.ioPolicy, base?.ioPolicy),
        naming: normalizeNaming(profile.naming, base?.naming),
        hardware: normalizeHardware(profile.hardware, base?.hardware)
    };
}

export function createDefaultUserPlcProfiles() {
    return DEFAULT_USER_PROFILE_DEFINITIONS.map((profile, index) => normalizePlcProfile(profile, index));
}

export function listPlcProfiles(userProfiles = []) {
    const normalizedUsers = Array.isArray(userProfiles)
        ? userProfiles.map((profile, index) => normalizePlcProfile(profile, index))
        : [];
    const merged = [];
    const seen = new Set();
    for (const profile of [...normalizedUsers, ...listBuiltInPlcProfiles()]) {
        if (seen.has(profile.id)) continue;
        seen.add(profile.id);
        merged.push(profile);
    }
    return merged;
}

export function resolvePlcProfile(profileId = "", userProfiles = []) {
    const profiles = listPlcProfiles(userProfiles);
    return profiles.find((profile) => profile.id === profileId)
        || getBuiltInPlcProfile(profileId)
        || getBuiltInPlcProfile("generic-st");
}

export function resolveActivePlcProfile(profileId = "", projectPlcProfiles = []) {
    return resolvePlcProfile(profileId, projectPlcProfiles);
}

export function buildPlcProfileOptions(userProfiles = []) {
    return listPlcProfiles(userProfiles).map((profile) => ({
        value: profile.id,
        label: `${profile.name} (${profile.editable ? "user" : "built-in"})`,
        editable: Boolean(profile.editable),
        kind: profile.editable ? "user" : "built-in",
        description: profile.description || ""
    }));
}

export function buildPlcProfileRuleLines(profile = {}) {
    const promptRules = String(profile.promptRules || "").trim();
    const promptLines = promptRules
        ? promptRules
            .split(/\r?\n+/)
            .map((line) => line.replace(/^[\s#\-*\u20220-9.)]+/, "").trim())
            .filter(Boolean)
        : [];
    if (promptLines.length) {
        return promptLines.slice(0, 10);
    }
    const normalized = normalizePlcProfile(profile);
    const lines = [];
    const codegen = normalized.codegen || {};
    const ioPolicy = normalized.ioPolicy || {};
    const naming = normalized.naming || {};
    const hardware = normalized.hardware || {};
    if (hardware.targetName || hardware.controllerModel) {
        lines.push(`ハード: ${hardware.targetName || "-"} / ${hardware.controllerModel || "-"}`);
    }
    if (hardware.ioSummary) {
        lines.push(`I/O構成: ${hardware.ioSummary}`);
    }
    lines.push(`宣言ブロック: ${codegen.declarationBlock || "VAR_GLOBAL"}`);
    lines.push(`点滅既定: ${Number.isFinite(Number(codegen.defaultBlinkMs)) ? Number(codegen.defaultBlinkMs) : 500}ms`);
    lines.push(codegen.preferIoMapping ? "I/O Mapping を優先" : "宣言側のアドレス表現を許容");
    lines.push(codegen.includeAddressesInDeclarations ? "宣言へアドレスを含める" : "宣言へアドレスを含めない");
    lines.push(ioPolicy.allowAtOnPouInterface ? "POU 入出力への AT を許可" : "POU 入出力への AT は非推奨");
    lines.push(ioPolicy.preferGlobalIoVariables ? "グローバル I/O を優先" : "グローバル I/O は必須ではない");
    if (naming.inputPrefix || naming.outputPrefix || naming.internalPrefix) {
        lines.push(`信号 prefix: IN ${naming.inputPrefix || "-"} / OUT ${naming.outputPrefix || "-"} / INT ${naming.internalPrefix || "-"}`);
    }
    if (ioPolicy.inputAddressPrefix || ioPolicy.outputAddressPrefix || ioPolicy.memoryAddressPrefix) {
        lines.push(`アドレス prefix: IN ${ioPolicy.inputAddressPrefix || "-"} / OUT ${ioPolicy.outputAddressPrefix || "-"} / INT ${ioPolicy.memoryAddressPrefix || "-"}`);
    }
    return lines;
}

export function buildPlcProfileEditorHints(profile = {}) {
    return collectPlcProfileConsistencyHints(profile).map((hint) => hint.message);
}

export function buildPlcProfileSummary(profile = {}) {
    const normalized = normalizePlcProfile(profile);
    const parts = [
        normalized.name || "PLCプロファイル",
        normalized.editable ? "user profile" : "built-in profile",
        normalized.baseFamily ? `family: ${normalized.baseFamily}` : "",
        normalized.vendorTarget ? `vendor: ${normalized.vendorTarget}` : ""
    ].filter(Boolean);
    return parts.join(" / ");
}

export function buildPlcProfileBaseLabel(profile = {}, userProfiles = []) {
    if (!profile?.editable) return "";
    const baseId = String(profile.baseProfileId || "").trim();
    if (!baseId) return "";
    const baseProfile = resolvePlcProfile(baseId, userProfiles);
    return String(baseProfile?.name || "").trim();
}

export function formatPlcProfileFieldLabel(path = "") {
    const key = String(path || "").replace(/^plcProfile\./, "");
    const labels = {
        "ioPolicy.allowAtOnPouInterface": "POU 入出力への AT 許可",
        "codegen.includeAddressesInDeclarations": "宣言へアドレスを含める",
        "codegen.declarationBlock": "宣言ブロック",
        "codegen.preferIoMapping": "I/O Mapping 優先",
        "ioPolicy.preferGlobalIoVariables": "グローバル I/O 優先",
        "ioPolicy.inputAddressPrefix": "入力アドレス prefix",
        "ioPolicy.outputAddressPrefix": "出力アドレス prefix",
        "ioPolicy.memoryAddressPrefix": "内部アドレス prefix",
        "naming.inputPrefix": "入力 prefix",
        "naming.outputPrefix": "出力 prefix",
        "naming.internalPrefix": "内部 prefix"
    };
    return labels[key] || "";
}

export function collectActivePlcProfileWarnings(profile = {}, findings = []) {
    const localWarnings = collectPlcProfileConsistencyHints(profile).map((hint) => ({
        code: hint.code || "",
        path: hint.path ? `plcProfile.${hint.path}` : "plcProfile",
        targetLabel: formatPlcProfileFieldLabel(hint.path || ""),
        message: hint.message || ""
    }));
    const apiWarnings = Array.isArray(findings)
        ? findings
            .filter((finding) => String(finding?.code || "").startsWith("PROFILE_"))
            .map((finding) => ({
                code: String(finding?.code || ""),
                path: String(finding?.path || ""),
                targetLabel: formatPlcProfileFieldLabel(String(finding?.path || "")),
                message: String(finding?.message || "").trim()
            }))
            .filter((finding) => finding.message)
        : [];
    const merged = new Map();
    for (const warning of [...localWarnings, ...apiWarnings]) {
        const key = [warning.code, warning.path, warning.message].join("|");
        if (!merged.has(key)) merged.set(key, warning);
    }
    return [...merged.values()];
}

export function buildInstructionWithPlcProfile(userInstruction = "", profile = {}) {
    const text = String(userInstruction || "").trim();
    if (!profile?.promptRules) return text;
    return [
        text || "追加指示なし",
        "",
        "[PLCプロファイル規則]",
        profile.promptRules
    ].join("\n");
}

export function getDialectMeta(dialect = "", activeProfile = null) {
    const requested = String(dialect || "").trim();
    const vendor = (() => {
        if (/^(generic-st|mitsubishi-gxworks3|mitsubishi-gx-works3|omron-sysmac|keyence-kv|codesys-st)$/.test(requested)) {
            return requested;
        }
        return activeProfile?.vendorTarget || "generic-st";
    })();
    const base = (() => {
        switch (vendor) {
            case "mitsubishi-gxworks3":
            case "mitsubishi-gx-works3":
                return {
                    label: "Mitsubishi GX Works3",
                    stepVar: "iStep",
                    startSignal: "X_StartCmd",
                    comment: "Mitsubishi-flavored draft"
                };
            case "omron-sysmac":
                return {
                    label: "Omron Sysmac Studio",
                    stepVar: "StepNo",
                    startSignal: "StartCmd",
                    comment: "Sysmac-flavored draft"
                };
            case "keyence-kv":
                return {
                    label: "Keyence KV Studio",
                    stepVar: "StepNo",
                    startSignal: "StartTrig",
                    comment: "KV-flavored draft"
                };
            case "codesys-st":
                return {
                    label: "CODESYS ST",
                    stepVar: "Step",
                    startSignal: "StartCmd",
                    comment: "CODESYS draft"
                };
            default:
                return {
                    label: "Generic IEC ST",
                    stepVar: "Step",
                    startSignal: "StartCmd",
                    comment: "Generic draft"
                };
        }
    })();
    return {
        label: activeProfile?.name || base.label,
        stepVar: activeProfile?.stepVar || base.stepVar,
        startSignal: activeProfile?.startSignal || base.startSignal,
        comment: activeProfile?.comment || base.comment,
        promptRules: activeProfile?.promptRules || "",
        vendorTarget: activeProfile?.vendorTarget || vendor,
        profileId: activeProfile?.id || requested || vendor
    };
}

export function buildChatDialectSyncState(activeProfile = null) {
    return {
        plcProfileId: String(activeProfile?.id || "generic-st").trim() || "generic-st",
        dialect: String(activeProfile?.vendorTarget || "generic-st").trim() || "generic-st",
        selectedPlcProfileId: String(activeProfile?.id || "generic-st").trim() || "generic-st"
    };
}

export function buildDuplicatedPlcProfile(baseProfile = {}, userProfiles = [], nextId = "") {
    const profiles = Array.isArray(userProfiles) ? userProfiles : [];
    return normalizePlcProfile({
        ...baseProfile,
        id: String(nextId || "").trim() || `profile-${Date.now()}`,
        name: `${String(baseProfile?.name || "PLC Profile").trim() || "PLC Profile"} Copy`,
        editable: true,
        baseProfileId: baseProfile?.baseProfileId || baseProfile?.id || "generic-st"
    }, profiles.length);
}

export function buildRemainingPlcProfilesAfterDelete(activeProfile = {}, userProfiles = []) {
    const profiles = Array.isArray(userProfiles) ? userProfiles : [];
    const activeId = String(activeProfile?.id || "").trim();
    if (!activeId) return [...profiles];
    return profiles.filter((profile) => profile.id !== activeId);
}

export function buildPlcProfileSaveCandidate(draft = {}) {
    const trimText = (value) => String(value || "").trim();
    return {
        ...draft,
        name: trimText(draft.name),
        description: trimText(draft.description),
        promptRules: trimText(draft.promptRules),
        editable: true,
        codegen: {
            ...draft.codegen,
            declarationBlock: trimText(draft.codegen?.declarationBlock) || "VAR_GLOBAL",
            includeAddressesInDeclarations: Boolean(draft.codegen?.includeAddressesInDeclarations),
            preferIoMapping: Boolean(draft.codegen?.preferIoMapping),
            defaultBlinkMs: Number(draft.codegen?.defaultBlinkMs)
        },
        ioPolicy: {
            ...draft.ioPolicy,
            allowAtOnPouInterface: Boolean(draft.ioPolicy?.allowAtOnPouInterface),
            preferGlobalIoVariables: Boolean(draft.ioPolicy?.preferGlobalIoVariables),
            inputAddressPrefix: trimText(draft.ioPolicy?.inputAddressPrefix),
            outputAddressPrefix: trimText(draft.ioPolicy?.outputAddressPrefix),
            memoryAddressPrefix: trimText(draft.ioPolicy?.memoryAddressPrefix)
        },
        naming: {
            ...draft.naming,
            inputPrefix: trimText(draft.naming?.inputPrefix),
            outputPrefix: trimText(draft.naming?.outputPrefix),
            internalPrefix: trimText(draft.naming?.internalPrefix)
        }
    };
}

export function buildSavedPlcProfiles(nextProfile = {}, userProfiles = []) {
    const profiles = Array.isArray(userProfiles) ? [...userProfiles] : [];
    const index = profiles.findIndex((profile) => profile.id === nextProfile?.id);
    const normalized = normalizePlcProfile(nextProfile, Math.max(index, 0));
    if (index >= 0) {
        profiles[index] = normalized;
    } else {
        profiles.push(normalized);
    }
    return {
        profiles,
        normalized
    };
}

export function updatePlcProfileDraftValue(draft = null, path = "", value = undefined) {
    if (!draft || typeof draft !== "object") return draft;
    const parts = String(path || "").split(".").filter(Boolean);
    if (!parts.length) return draft;
    let cursor = draft;
    for (let i = 0; i < parts.length - 1; i += 1) {
        const key = parts[i];
        if (!cursor[key] || typeof cursor[key] !== "object") cursor[key] = {};
        cursor = cursor[key];
    }
    cursor[parts[parts.length - 1]] = value;
    return draft;
}

export function buildProjectPlcProfilesState(project = {}) {
    if (!project || typeof project !== "object") {
        return {
            plcProfiles: [],
            plcProfilesSeeded: true
        };
    }
    const list = Array.isArray(project.plcProfiles) ? project.plcProfiles : [];
    const source = project.plcProfilesSeeded ? list : [...list, ...createDefaultUserPlcProfiles()];
    const normalized = [];
    const seen = new Set();
    for (let i = 0; i < source.length; i += 1) {
        const profile = normalizePlcProfile(source[i], i);
        if (!profile.editable) continue;
        if (seen.has(profile.id)) continue;
        seen.add(profile.id);
        normalized.push(profile);
    }
    return {
        plcProfiles: normalized,
        plcProfilesSeeded: true
    };
}

export function ensureProjectPlcProfiles(project = {}) {
    if (!project || typeof project !== "object") return [];
    const nextState = buildProjectPlcProfilesState(project);
    project.plcProfiles = nextState.plcProfiles;
    project.plcProfilesSeeded = nextState.plcProfilesSeeded;
    return project.plcProfiles;
}

export function getActivePlcProfile(profileId = "", project = {}) {
    const profiles = ensureProjectPlcProfiles(project);
    return resolveActivePlcProfile(profileId, profiles);
}

export function syncChatDialectFromProfile(chat = {}, project = null, activeProfile = null) {
    const nextState = buildChatDialectSyncState(activeProfile);
    if (chat && typeof chat === "object") {
        chat.plcProfileId = nextState.plcProfileId;
        chat.dialect = nextState.dialect;
    }
    if (project && typeof project === "object") {
        project.selectedPlcProfileId = nextState.selectedPlcProfileId;
    }
    return activeProfile;
}

export function resolveDialectMeta(dialect = "", chat = {}, project = {}) {
    const requested = String(dialect || "").trim();
    const activeProfile = getActivePlcProfile(requested || chat?.plcProfileId || chat?.dialect, project);
    return getDialectMeta(requested, activeProfile);
}

export function cancelPlcProfileEdit(chat = {}, buildClosedPlcProfileEditorStateImpl = buildClosedPlcProfileEditorState) {
    if (!chat || typeof chat !== "object") return false;
    chat.plcProfileEditor = buildClosedPlcProfileEditorStateImpl();
    return true;
}

export function updatePlcProfileDraft(chat = {}, path = "", value = undefined, updatePlcProfileDraftValueImpl = updatePlcProfileDraftValue) {
    const editor = chat?.plcProfileEditor;
    if (!editor?.draft) return false;
    updatePlcProfileDraftValueImpl(editor.draft, path, value);
    editor.error = "";
    return true;
}

export function savePlcProfileEdit(deps = {}) {
    const {
        chat = {},
        project = {},
        ensureProjectPlcProfilesImpl = ensureProjectPlcProfiles,
        buildPlcProfileSaveCandidateImpl = buildPlcProfileSaveCandidate,
        validatePlcProfileForSaveImpl = () => [],
        buildSavedPlcProfilesImpl = buildSavedPlcProfiles,
        buildClosedPlcProfileEditorStateImpl = buildClosedPlcProfileEditorState,
        focusPlcProfileField = () => {},
        applySavedProfileSelection = () => {}
    } = deps;
    const editor = chat?.plcProfileEditor;
    if (!editor?.draft) return false;
    const draft = editor.draft;
    const profiles = ensureProjectPlcProfilesImpl(project);
    const candidate = buildPlcProfileSaveCandidateImpl(draft);
    const saveErrors = validatePlcProfileForSaveImpl(candidate);
    if (saveErrors.length) {
        editor.error = saveErrors[0].message;
        focusPlcProfileField(saveErrors[0].path || "");
        return false;
    }
    const saved = buildSavedPlcProfilesImpl(candidate, profiles);
    project.plcProfiles = saved.profiles;
    chat.plcProfileEditor = buildClosedPlcProfileEditorStateImpl();
    applySavedProfileSelection(saved.normalized.id);
    return true;
}

export function duplicateActivePlcProfile(deps = {}) {
    const {
        baseProfile = null,
        project = {},
        chat = {},
        ensureProjectPlcProfilesImpl = ensureProjectPlcProfiles,
        buildDuplicatedPlcProfileImpl = buildDuplicatedPlcProfile,
        buildOpenPlcProfileEditorStateImpl = buildOpenPlcProfileEditorState,
        nextId = `profile-${Date.now()}`,
        applySavedProfileSelection = () => {}
    } = deps;
    const profiles = ensureProjectPlcProfilesImpl(project);
    const next = buildDuplicatedPlcProfileImpl(baseProfile, profiles, nextId);
    profiles.push(next);
    applySavedProfileSelection(next.id);
    chat.plcProfileEditor = buildOpenPlcProfileEditorStateImpl(next);
    return next;
}

export function editActivePlcProfile(activeProfile = null, buildPlcProfileEditActionStateImpl = buildPlcProfileEditActionState) {
    const editState = buildPlcProfileEditActionStateImpl(activeProfile);
    return editState;
}

export function focusPlcProfileField(deps = {}) {
    const {
        path = "",
        activeProfile = null,
        chat = {},
        buildPlcProfileEditActionStateImpl = buildPlcProfileEditActionState,
        buildPlcProfileFieldFocusStateImpl = buildPlcProfileFieldFocusState
    } = deps;
    const editState = buildPlcProfileEditActionStateImpl(activeProfile);
    const focusState = buildPlcProfileFieldFocusStateImpl(path, activeProfile, chat?.plcProfileEditor?.open);
    if (!focusState.normalizedPath) {
        return {
            editState,
            focusState,
            shouldNotify: false
        };
    }
    if (!focusState.blocked && focusState.shouldOpenEditor) {
        chat.plcProfileEditor = editState.editorState;
    }
    return {
        editState,
        focusState,
        shouldNotify: !focusState.blocked
    };
}

export function deleteActivePlcProfile(deps = {}) {
    const {
        activeProfile = null,
        project = {},
        ensureProjectPlcProfilesImpl = ensureProjectPlcProfiles,
        buildRemainingPlcProfilesAfterDeleteImpl = buildRemainingPlcProfilesAfterDelete,
        applyFallbackSelection = () => {}
    } = deps;
    if (!activeProfile?.editable) return false;
    project.plcProfiles = buildRemainingPlcProfilesAfterDeleteImpl(activeProfile, ensureProjectPlcProfilesImpl(project));
    applyFallbackSelection(activeProfile.baseProfileId || "generic-st");
    return true;
}

export function buildOpenPlcProfileEditorState(profile = null) {
    return {
        open: true,
        draft: profile == null ? null : JSON.parse(JSON.stringify(profile)),
        error: ""
    };
}

export function buildClosedPlcProfileEditorState() {
    return {
        open: false,
        draft: null,
        error: ""
    };
}

export function buildPlcProfileFieldFocusState(path = "", activeProfile = null, editorOpen = false) {
    const normalizedPath = String(path || "").replace(/^plcProfile\./, "").trim();
    return {
        normalizedPath,
        blocked: Boolean(normalizedPath) && !editorOpen && !Boolean(activeProfile?.editable),
        shouldOpenEditor: Boolean(normalizedPath) && !editorOpen && Boolean(activeProfile?.editable)
    };
}

export function buildPlcProfileEditActionState(activeProfile = null) {
    const canEdit = Boolean(activeProfile?.editable);
    return {
        canEdit,
        blockedMessage: canEdit ? "" : "built-in プロファイルは直接編集できません。複製してから編集してください。",
        editorState: canEdit ? buildOpenPlcProfileEditorState(activeProfile) : null
    };
}

export function normalizePlcProfileSelectionValue(value = "") {
    return String(value || "generic-st").trim() || "generic-st";
}

export function collectPlcProfileConsistencyHints(profile = {}) {
    const normalized = normalizePlcProfile(profile);
    const hints = [];
    const codegen = normalized.codegen || {};
    const ioPolicy = normalized.ioPolicy || {};
    const declarationBlock = String(codegen.declarationBlock || "").trim().toUpperCase();

    if (normalized.baseFamily === "codesys" && ioPolicy.allowAtOnPouInterface) {
        hints.push({
            code: "PROFILE_CODESYS_AT_ON_INTERFACE",
            message: "CODESYS 系では POU の VAR_INPUT / VAR_OUTPUT に AT を付けない方が安全です。",
            path: "ioPolicy.allowAtOnPouInterface"
        });
    }
    if (codegen.preferIoMapping && codegen.includeAddressesInDeclarations) {
        hints.push({
            code: "PROFILE_IO_MAPPING_AND_INLINE_ADDRESS",
            message: "I/O Mapping 優先と宣言へのアドレス含有が同時に有効です。主方針を揃えると分かりやすくなります。",
            path: "codegen.includeAddressesInDeclarations"
        });
    }
    if (ioPolicy.preferGlobalIoVariables && declarationBlock !== "VAR_GLOBAL") {
        hints.push({
            code: "PROFILE_GLOBAL_IO_WITH_NON_GLOBAL_DECL",
            message: "グローバル I/O 優先なら、宣言ブロックも VAR_GLOBAL に揃えると方針と一致します。",
            path: "codegen.declarationBlock"
        });
    }
    return hints;
}

export function validatePlcProfileForSave(profile = {}) {
    const normalized = normalizePlcProfile(profile);
    const errors = [];
    const codegen = normalized.codegen || {};
    const ioPolicy = normalized.ioPolicy || {};
    const naming = normalized.naming || {};
    const declarationBlock = String(codegen.declarationBlock || "").trim().toUpperCase();
    const allowedBlocks = new Set(["VAR_GLOBAL", "VAR"]);
    const hasWhitespace = (value) => /\s/.test(String(value || ""));

    if (!String(normalized.name || "").trim()) {
        errors.push({
            code: "PROFILE_NAME_REQUIRED",
            message: "プロファイル名を入力してください。",
            path: "name"
        });
    }
    if (!allowedBlocks.has(declarationBlock)) {
        errors.push({
            code: "PROFILE_INVALID_DECLARATION_BLOCK",
            message: "宣言ブロックは VAR_GLOBAL または VAR を指定してください。",
            path: "codegen.declarationBlock"
        });
    }
    if (!Number.isFinite(Number(codegen.defaultBlinkMs)) || Number(codegen.defaultBlinkMs) <= 0) {
        errors.push({
            code: "PROFILE_INVALID_BLINK_MS",
            message: "点滅既定(ms) には 1 以上の数値を入力してください。",
            path: "codegen.defaultBlinkMs"
        });
    }
    if (normalized.baseFamily === "codesys" && ioPolicy.allowAtOnPouInterface) {
        errors.push({
            code: "PROFILE_CODESYS_AT_ON_INTERFACE_BLOCKED",
            message: "CODESYS 系では POU の VAR_INPUT / VAR_OUTPUT に AT を付けない方針のため、この設定では保存できません。",
            path: "ioPolicy.allowAtOnPouInterface"
        });
    }
    if (ioPolicy.preferGlobalIoVariables && declarationBlock !== "VAR_GLOBAL") {
        errors.push({
            code: "PROFILE_GLOBAL_IO_REQUIRES_VAR_GLOBAL",
            message: "グローバル I/O 優先を使う場合、宣言ブロックは VAR_GLOBAL にしてください。",
            path: "codegen.declarationBlock"
        });
    }

    const fields = [
        ["naming.inputPrefix", naming.inputPrefix],
        ["naming.outputPrefix", naming.outputPrefix],
        ["naming.internalPrefix", naming.internalPrefix],
        ["ioPolicy.inputAddressPrefix", ioPolicy.inputAddressPrefix],
        ["ioPolicy.outputAddressPrefix", ioPolicy.outputAddressPrefix],
        ["ioPolicy.memoryAddressPrefix", ioPolicy.memoryAddressPrefix]
    ];
    for (const [path, value] of fields) {
        if (value && hasWhitespace(value)) {
            errors.push({
                code: "PROFILE_FIELD_CONTAINS_WHITESPACE",
                message: "prefix には空白を含めないでください。",
                path
            });
        }
    }
    for (const [path, value] of [
        ["ioPolicy.inputAddressPrefix", ioPolicy.inputAddressPrefix],
        ["ioPolicy.outputAddressPrefix", ioPolicy.outputAddressPrefix],
        ["ioPolicy.memoryAddressPrefix", ioPolicy.memoryAddressPrefix]
    ]) {
        if (value && !String(value).startsWith("%")) {
            errors.push({
                code: "PROFILE_ADDRESS_PREFIX_FORMAT",
                message: "アドレス prefix は % から始めてください。",
                path
            });
        }
    }

    return errors;
}
